import googleAnalytics from '@analytics/google-analytics';

export default function getPlugin(hubGaId) {
  return {
    ...googleAnalytics({
      trackingId: hubGaId
    })
  };
}
